/*
  store相关的辅助函数
 */
import { cmtadcf, channel, browserPartner } from './constants';
import { query } from '@js/utils';
import { getIsShowMainAndrelatedNews } from './utils';
import wv from '@cpc/lib-browser-jsapi';
import { brandName, getDocId } from '@js/utils-feeds';
import { getAccessByType } from './access';
import { BrowserBridgeHandler } from './browserBridgeHandler';
import Browser from '../../common/js/browser';


export function useCommentSdk() {
  const queryValue = query.get('__comment_sdk__');
  const abTest = wv.getConfigValue && wv.getConfigValue('ABTest.comment_sdk');
  return queryValue === '1' || (abTest && abTest.code === 0 && abTest.data);
}

export function getCommentAdPosition() {
  const adcfGroup = query.get('__cmtadcf__')
    ? query.get('__cmtadcf__').split(';')
    : 3;
  return Number(adcfGroup) || 3;
}

export function getAdShield() {
  const queryValue = query.get('__adShield__');

  if (queryValue) {
    return queryValue.split('_');
  }

  if (!wv.isMethodValid('getConfigValue')) {
    return [];
  }

  const abTest = wv.getConfigValue('ABTest.adShield');
  const adShield = (abTest && abTest.code === 0 && abTest.data) || null;
  return adShield?.split('_') || [];
}

function handleUrlQuery(url, commentStatus) {
  // 测试环境命中字段
  query.get('appFrom') && (url += `&appFrom=${query.get('appFrom')}`);

  process.env.OFET_PAGE_TYPE === 'feednewsThird' &&
    (url += `&third_party=${window.pageData.DOCINFO.vendor}`);

  commentStatus === 2 && (url += '&__comment__=0_0&__barStyle__=1_2');

  return url;
}

function genCommentUrl(type) {
  const pageHost = getAccessByType('baseUri');
  return `${pageHost}${type}/${getDocId()}?s=${brandName}browser&appid=${brandName}browser&__cmtadcf__=${cmtadcf}`;
}
export function getCommentMoreUrl(commentStatus) {
  let commentMoreUrl = genCommentUrl('comment');
  return handleUrlQuery(commentMoreUrl, commentStatus);
}

export function getReplyPageUrl(commentStatus) {
  let replyPageUrl = genCommentUrl('secondComment');
  return handleUrlQuery(replyPageUrl, commentStatus);
}

export function getCommentStatus() {
  let commentStatus;
  const queryCommentStatus = query.get('__comment__') || '';

  const statusMap = {
    '1_1': 0, //显示评论，能发评论
    '1_0': 1, // 显示评论，不能发评论
    '0_0': 2, // 不显示评论，不能发评论
  };
  commentStatus = statusMap[queryCommentStatus] || 0;
  // 0-不屏蔽 1-评论展示，但不能回复 2-评论不展示且禁止评论
  let getCommentSwitchStatus =
    wv && wv.getCommentSwitchStatus && wv.getCommentSwitchStatus();
  commentStatus =
    (getCommentSwitchStatus && getCommentSwitchStatus.data) || commentStatus;
  return commentStatus;
}

// 判断是否需要进行折叠功能展示
export function isShowFold() {
  let mediaBar = document.querySelector("div[component='mediaBar']");
  let article = document.querySelector('.article article');
  let mediaBarHeight = 0; //标题和媒体栏高度
  let articleHeight; // 文章高度
  if (mediaBar) {
    mediaBarHeight = mediaBar.clientHeight;
  }
  if (article) {
    articleHeight = article.clientHeight;
  }
  const screenHeight = window.screen.height;

  // 此处是负一屏跳转过来的折叠 逻辑

  // 超过2倍屏幕展示折叠功能
  let showHeight = screenHeight * 2;
  let obj = {
    heightValue: showHeight - mediaBarHeight,
    isShow: false,
  };
  let configValue = 0;
  // 获取折叠接口是返回来的数据,1:折叠,0:不折叠
  if (window.wv.isMethodValid('BrowserIFlow.getConfigValue')) {
    configValue = window.wv.invoke(
      'BrowserIFlow.getConfigValue',
      'ABTest.assistantscreen_textFold',
    ).data;
  }

  // if (process.env.NODE_ENV === 'development') {
  //   configValue = 1;
  // }


  //文章详情大于1.5屏时且存在URL参数存在iflowApp(负一屏跳过来的参数)且折叠接口返回来的是1,则隐藏来源和分享模块,进行折叠
  if (
    articleHeight > obj.heightValue &&
    getIsShowMainAndrelatedNews() &&
    configValue === 1
  ) {
    obj.isShow = true;
  }

  // 折叠开关配置 查看doc:https://doc.myoas.com/pages/viewpage.action?pageId=612888815 (搜 全文折叠客户端配置开关)
  // try {
  //   const articleFoldConfig = BrowserBridgeHandler.getArticleFoldConfig();
  //   if (articleFoldConfig?.switch?.oppo) {
  //     const sceneList = articleFoldConfig?.condition?.or?.sceneList || [];
  //     const queryList = articleFoldConfig?.condition?.or?.query || [];
  //     // 获取配置的是屏幕的倍数 最终高度需要乘以屏幕高度
  //     const minArticleHeight = (articleFoldConfig?.condition?.minArticleHeight || 1) * screenHeight;
  //     const startFoldPos = (articleFoldConfig?.startFoldPos || 1) * screenHeight;

  //     const isMatchScene = sceneList.some((item) => {
  //       if (item === 'push') {
  //         return channel;
  //       }
  //       if (item === 'list') {
  //         return query.has('iflowScene') ? query.get('iflowScene') === 'list_browser' : Browser.isOppoBrowser() && !channel;
  //       }
  //     });

  //     const isMatchQuery = queryList.some((item) => {
  //       // 判断query 参数
  //       if (BrowserBridgeHandler.isObject(item)) {
  //         if (typeof item.value !== 'undefined') {
  //           return query.get(item.key) == item.value
  //         }
  //         return query.has(item.key)
  //       }
  //     });

  //     console.log(`isMatchScene:${isMatchScene},isMatchQuery:${isMatchQuery},articleHeight:${articleHeight}`);
  //     if ((isMatchScene || isMatchQuery) && articleHeight >= minArticleHeight) {
  //       console.log('新折叠开关');
  //       obj.isShow = true;
  //       obj.heightValue = Math.min(articleHeight, startFoldPos); // 开始折叠的高度 不能大于文章高度
  //     }
  //   }
  // } catch (error) {
  //   console.log(error);
  // }


  const docId = window.pageData.DOCINFO.docId;
  const cacheData = window.localStorage.getItem('__showMoreCache__') || '[]';
  const docIds = JSON.parse(cacheData);

  try {
    // 天气走独立开关配置, 如果没有折叠就走模块化开关
    if (browserPartner === 'weather') {
      const articleFoldConfig = BrowserBridgeHandler.getArticleFoldConfig();
      if (articleFoldConfig?.switch?.oppo) {
        const sceneList = articleFoldConfig?.condition?.or?.sceneList || [];
        const queryList = articleFoldConfig?.condition?.or?.query || [];
        // 获取配置的是屏幕的倍数 最终高度需要乘以屏幕高度
        const minArticleHeight = (articleFoldConfig?.condition?.minArticleHeight || 1) * screenHeight;
        const startFoldPos = (articleFoldConfig?.startFoldPos || 1) * screenHeight;

        const isMatchScene = sceneList.some((item) => {
          if (item === 'weather') {
            return browserPartner === 'weather';
          }
          if (item === 'push') {
            return channel;
          }
          if (item === 'list') {
            return query.has('iflowScene') ? query.get('iflowScene') === 'list_browser' : Browser.isOppoBrowser() && !channel;
          }
        });

        const isMatchQuery = queryList.some((item) => {
          // 判断query 参数
          if (BrowserBridgeHandler.isObject(item)) {
            if (typeof item.value !== 'undefined') {
              return query.get(item.key) == item.value
            }
            return query.has(item.key)
          }
        });

        if ((isMatchScene || isMatchQuery) && articleHeight >= minArticleHeight && docIds.indexOf(docId) === -1) {
          console.log('天气折叠开关');
          obj.isShow = true;
          obj.heightValue = Math.min(articleHeight, startFoldPos); // 开始折叠的高度 不能大于文章高度
          return obj;
        }
      }
    }


    // 模块化配置
    const articleFoldConfig = window.modulesConfig?.showMore;
    if (articleFoldConfig?.isShow) {
      // 获取配置的是屏幕的倍数 最终高度需要乘以屏幕高度
      const minArticleHeight =
        (articleFoldConfig?.minArticleHeight || 1) * screenHeight;
      const startFoldPos =
        (articleFoldConfig?.startFoldPos || 1) * screenHeight;

      const docId = window.pageData.DOCINFO.docId;
      const cacheData =
        window.localStorage.getItem('__showMoreCache__') || '[]';
      const docIds = JSON.parse(cacheData);
      if (articleHeight >= minArticleHeight && docIds.indexOf(docId) === -1) {
        console.log('新折叠开关');
        obj.isShow = true;
        obj.heightValue = Math.min(articleHeight, startFoldPos); // 开始折叠的高度 不能大于文章高度
      }
    }
  } catch (error) {
    console.log(error);
  }
  return obj;
}
